import * as React from 'react'
import type {SVGProps} from 'react'
const SvgRing = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={25}
        height={25}
        viewBox="0 0 25 25"
        {...props}
    >
        <g id="icon" transform="translate(7.668 -7.401) rotate(-40)">
            <path
                id="ring-thin"
                d="M3.285,65.965A15.911,15.911,0,0,1,10,64.625a15.911,15.911,0,0,1,6.715,1.34c1.723.836,2.66,1.93,2.66,3.035a2.827,2.827,0,0,1-1.187,2.105,8.11,8.11,0,0,0-1.2-.7A16.474,16.474,0,0,0,10,69a16.474,16.474,0,0,0-6.984,1.4,8.315,8.315,0,0,0-1.2.7A2.827,2.827,0,0,1,.625,69C.625,67.895,1.562,66.8,3.285,65.965Zm16.7,2.723c-.16-1.344-1.34-2.48-3-3.285A16.474,16.474,0,0,0,10,64a16.474,16.474,0,0,0-6.984,1.4c-1.656.8-2.836,1.941-3,3.285H0V74.02C0,75.5,1.234,76.742,3.016,77.6A16.476,16.476,0,0,0,10,79a16.476,16.476,0,0,0,6.984-1.4C18.766,76.742,20,75.5,20,74.02V68.688Zm-.605,2.078V74.02c0,1.1-.937,2.188-2.66,3.02A15.9,15.9,0,0,1,10,78.375a15.9,15.9,0,0,1-6.715-1.336c-1.723-.832-2.66-1.918-2.66-3.02V70.766a6.4,6.4,0,0,0,2.391,1.828A16.412,16.412,0,0,0,10,74a16.474,16.474,0,0,0,6.984-1.4,6.473,6.473,0,0,0,2.391-1.828Zm-16.09,1.27A7.914,7.914,0,0,1,2.34,71.5a7.914,7.914,0,0,1,.945-.535A15.911,15.911,0,0,1,10,69.625a15.911,15.911,0,0,1,6.715,1.34,7.914,7.914,0,0,1,.945.535,7.914,7.914,0,0,1-.945.535A15.911,15.911,0,0,1,10,73.375a15.911,15.911,0,0,1-6.715-1.34Z"
                transform="translate(-18.852 -52.916)"
                fill="#142745"
                stroke="#142745"
                strokeWidth="0.5"
            />
        </g>
    </svg>
)
export default SvgRing
